// extracted by mini-css-extract-plugin
export var archived = "styles-module--archived--92327";
export var blueBorder = "styles-module--blueBorder--0c070";
export var buttonsContainer = "styles-module--buttonsContainer--b36c9";
export var card = "styles-module--card--33d1e";
export var contentBox = "styles-module--contentBox--18768";
export var iconsAndStatus = "styles-module--iconsAndStatus--13bae";
export var iconsContainer = "styles-module--iconsContainer--bfbbd";
export var imageAndTitle = "styles-module--imageAndTitle--8a1c0";
export var lightBlueBorder = "styles-module--lightBlueBorder--877f0";
export var yellowBorder = "styles-module--yellowBorder--d0474";